// Static educational content for KRV Prime (non-CMS structural content)

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Courses", to: "/courses" },
  { label: "Market Insights", to: "/research" },
  { label: "Participant OI", to: "/participant-oi" },
  {
    label: "Tools",
    children: [
      { label: "Calculators", to: "/calculators" },
      { label: "Scanners", to: "/scanners" },
    ],
  },
  {
    label: "Resources",
    children: [
      { label: "Books", to: "/books" },
      { label: "Webinars & Events", to: "/events" },
      { label: "Knowledge Center", to: "/knowledge" },
      { label: "Strategy Library", to: "/strategy" },
      { label: "Contact", to: "/contact" },
    ],
  },
  { label: "About", to: "/about" },
];

export const PILLARS = [
  { key: "Learn", title: "Learn", desc: "Systematic financial-market education, from fundamentals to advanced frameworks." },
  { key: "Analyse", title: "Analyse", desc: "Market analysis and educational insights from data and derivatives." },
  { key: "Build", title: "Build", desc: "Develop disciplined frameworks and rule-based systems." },
];

export const THREE_PILLAR_MODEL = [
  { title: "Education", desc: "Structured learning from fundamentals to advanced market concepts.", icon: "GraduationCap" },
  { title: "Analyse", desc: "Market observations, analytical frameworks and educational insights.", icon: "LineChart" },
  { title: "Systems", desc: "Rule-based frameworks for understanding and studying market behaviour.", icon: "Boxes" },
];

export const LEARNING_PATH = [
  {
    level: "Level 1", name: "Foundation",
    topics: ["Financial market basics", "Stocks", "Indices", "Futures", "Options", "Market terminology", "Order types", "Risk basics"],
  },
  {
    level: "Level 2", name: "Market Analysis",
    topics: ["Price action", "Support & resistance", "Trend", "Market structure", "Volume", "Volatility", "Technical indicators"],
  },
  {
    level: "Level 3", name: "Systematic Trading",
    topics: ["CPR", "Pivot Points", "Camarilla Pivots", "VWAP", "EMA frameworks", "RSI", "SuperTrend", "ORB", "Initial Balance", "Bollinger Bands", "Volume Profile"],
  },
  {
    level: "Level 4", name: "Advanced Frameworks",
    topics: ["Strategy design", "Multi-timeframe analysis", "Entry frameworks", "Exit frameworks", "Risk management", "Position sizing", "Backtesting concepts", "Trading psychology", "System evaluation"],
  },
];

export const MAEE = [
  { letter: "M", title: "Market Structure", desc: "Understand the broader market environment before interpreting price." },
  { letter: "A", title: "Area of Value", desc: "Identify important price and value zones where decisions concentrate." },
  { letter: "E", title: "Entry Trigger", desc: "Wait for a defined, repeatable confirmation before acting." },
  { letter: "E", title: "Exit Trigger", desc: "Manage target, stop-loss and trade invalidation with discipline." },
];

export const PHILOSOPHY = [
  { title: "Structure", desc: "Understand the market before interpreting it." },
  { title: "Evidence", desc: "Use data and observable behaviour." },
  { title: "Discipline", desc: "Follow defined processes rather than emotions." },
  { title: "Risk", desc: "Understand what can go wrong before focusing on returns." },
  { title: "Learning", desc: "Treat markets as a continuous learning environment." },
];

export const RESEARCH_DESK = [
  { title: "Index Analysis", items: ["NIFTY", "BANKNIFTY", "Other indices"] },
  { title: "Equity Analysis", items: ["Selected stocks", "Sector analysis", "Market themes"] },
  { title: "Derivatives Analysis", items: ["Open Interest", "Put-Call Ratio", "Futures positioning", "Options structure"] },
  { title: "Volatility", items: ["India VIX", "Volatility context", "Market regimes"] },
  { title: "Participant Data", items: ["FII", "DII", "Client", "Proprietary"] },
];

export const DASHBOARD_WIDGETS = [
  { name: "NIFTY 50", value: "24,812.35", change: "+0.42%", up: true, type: "Educational/Derived" },
  { name: "BANK NIFTY", value: "53,104.80", change: "-0.18%", up: false, type: "Educational/Derived" },
  { name: "India VIX", value: "12.84", change: "-2.10%", up: false, type: "Educational/Derived" },
  { name: "NIFTY PCR", value: "0.92", change: "+0.05", up: true, type: "Educational/Derived" },
  { name: "FII (Cash)", value: "₹ +1,240 Cr", change: "Net Buy", up: true, type: "End-of-Day" },
  { name: "DII (Cash)", value: "₹ -430 Cr", change: "Net Sell", up: false, type: "End-of-Day" },
];

export const EVENTS = [
  { title: "Understanding Market Structure — Live Webinar", date: "2026-06-21", time: "07:00 PM IST", speaker: "KRV Prime Market Insights", desc: "A structured session on reading market structure objectively.", status: "Registration Open" },
  { title: "Options & Open Interest Workshop", date: "2026-07-05", time: "11:00 AM IST", speaker: "KRV Prime Faculty", desc: "An educational workshop on the option chain, OI and PCR.", status: "Registration Open" },
  { title: "Risk Management for Students", date: "2026-07-19", time: "05:00 PM IST", speaker: "KRV Prime Faculty", desc: "A student-focused seminar on capital preservation and responsible learning.", status: "Coming Soon" },
];

export const FAQ = [
  { q: "Is KRV Prime a SEBI Registered Investment Adviser or Research Analyst?", a: "No. KRV Prime provides educational and informational content only. We are not a SEBI Registered Investment Adviser, Research Analyst, stockbroker or portfolio manager, and we do not provide personalised investment advice." },
  { q: "Do you guarantee profits or returns?", a: "No. We never promise profits, guaranteed returns or fixed income. Financial markets involve risk including the possible loss of capital." },
  { q: "Who is this platform for?", a: "Working professionals, college students, beginners and serious learners who want systematic financial-market education." },
  { q: "What makes KRV Prime different?", a: "We focus on structure, process, research and disciplined thinking instead of trading hype or isolated tips." },
];
